import React, { useContext } from "react"
import { PriceContext } from "../PriceContext"
import * as styles from "./style.module.scss"

interface Props {
  index: number
}

const RenderMobileTariff = ({ index }: Props) => {
  const { text, team } = useContext(PriceContext)

  const labelMap = team === "marketing" ? ["Marketing", "MarketingExpert", "EnterpriseMarketing"] : ["Conversation", "Support", "EnterpriseSupport"]

  const key = labelMap[index]

  return key ? <p className={styles.addonName}>{text.addonText[key]}</p> : null
}

export default RenderMobileTariff
